import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksStaffPayments(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].getOrderGeneratorsFieldsWorksStaffPayments,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksStaffPayment(companyId, generatorId, staffPaymentId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].getOrderGeneratorsFieldsWorksStaffPayment,
		{
			urlParams: {
				companyId,
        generatorId,
				staffPaymentId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksStaffPayment(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].createOrderGeneratorsFieldsWorksStaffPayment,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksStaffPayment(companyId, generatorId, staffPaymentId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].putOrderGeneratorsFieldsWorksStaffPayment,
		{
			urlParams: {
				companyId,
        generatorId,
				staffPaymentId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksStaffPayment(companyId, generatorId, staffPaymentId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].patchOrderGeneratorsFieldsWorksStaffPayment,
		{
			urlParams: {
				companyId,
        generatorId,
				staffPaymentId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksStaffPayment(companyId, generatorId, staffPaymentId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].deleteOrderGeneratorsFieldsWorksStaffPayment,
		{
			urlParams: {
				companyId,
        generatorId,
				staffPaymentId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksStaffPayments,
	getOrderGeneratorsFieldsWorksStaffPayment,
	createOrderGeneratorsFieldsWorksStaffPayment,
	putOrderGeneratorsFieldsWorksStaffPayment,
	patchOrderGeneratorsFieldsWorksStaffPayment,
	deleteOrderGeneratorsFieldsWorksStaffPayment,
}

